




import mixins from 'vue-typed-mixins'
import routeMixin from '@/router/routeMixin'
import _ from 'lodash'

export default mixins(routeMixin).extend({})
